import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagsContentComponent } from './tags-content.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [TagsContentComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [TagsContentComponent]
})
export class TagsContentModule { }
